import React, { useContext } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import styled, { ThemeProvider } from 'styled-components'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { Box, LightTheme } from 'ui/bend'
import AloIcon from '../../../../assets/codicons/a.svg'

import MasonryLayout from '../../masonryLayout/MasonryLayout'
import { SeriesCard } from 'components_v1/SchemaSectionRenderer/common/components'
import { ExplorePageContext } from 'components_v1/pageLevelComponents/explore/browseBy/ExploreFilterPage'

const BoxComponent = ({ product, idx }) => {
  const data = useContext(ExplorePageContext)

  return (
    <div className='card-container'>
      <Box mx={'calc(24*(100vw/1440))'}>
        <SeriesCard
          key={product.id}
          idx={idx}
          {...product.ref}
          isFevIcon={Boolean(data?.userPresent)}
        />
      </Box>
    </div>
  )
}

const MainProductMasory = styled.div`
  .series-card-container {
      display: flex;
      flex-wrap: wrap;
      .card-container {
        width: 100%;
        margin-bottom: 40px;
        @media screen and (min-width: 640px) {
          width: 50%;
        }
        @media screen and (min-width: 992px) {
          width: 33.3%;
        }
        
      }
      
      @media (min-width: 768px) and (max-width: 1024px) {
        width: calc(90% + 50px);
        margin: 0 auto;
      }
      @media screen and (min-width: 1025px) {
        width: 100%;
        margin: 0;
      }
    }
`

class ProductMasonry extends React.Component {
  componentDidUpdate() {
    let masonryLayout =
      this.productMasonry.getElementsByClassName('masonry-layout')[0]
    if (masonryLayout) {
      let columns = masonryLayout.querySelector('div').childNodes

      // Assume first column has the most number of cards
      let numRows = columns[0].childElementCount
      for (var i = 0; i < numRows; i++) {
        let rowMaxHeight = this.getTallestHeightInRow(columns, i)
        this.setRowHeights(rowMaxHeight, columns, i)
      }
    }
  }

  renderLayout(productTiles) {
    if (this.props.layout === 'list') {
      return <div className='series-card-container'>{productTiles}</div>
    } else {
      let cards = productTiles.map((productTile, idx) => {
        return (
          <div key={idx} className='product'>
            {productTile}
          </div>
        )
      })
      return (
        <div className='product-cards products-grid compact-xs'>{cards}</div>
      )
    }
  }

  cardHeightChange(idx) {
    if (window.innerWidth > 768) {
      let masonryLayout =
        this.productMasonry.getElementsByClassName('masonry-layout')[0]
      if (masonryLayout) {
        let columns = masonryLayout.querySelector('div').childNodes
        columns = Array.from(columns).filter((col) => {
          return col.childElementCount > 0
        })

        let rowNumber = Math.floor(idx / columns.length)
        let rowMaxHeight = this.getTallestHeightInRow(columns, rowNumber)
        this.setRowHeights(rowMaxHeight, columns, rowNumber)
      }
    }
  }

  getTallestHeightInRow(columns, rowNumber) {
    let rowMaxHeight = 0

    columns.forEach((column) => {
      let cards = column.getElementsByClassName('product-card')
      let neighbor = cards[rowNumber]
      if (neighbor) {
        let neighborTitleHeight =
          neighbor.querySelector('.varied-height').clientHeight
        if (neighborTitleHeight > rowMaxHeight) {
          rowMaxHeight = neighborTitleHeight
        }
      }
    })

    return rowMaxHeight
  }

  setRowHeights(rowMaxHeight, columns, rowNumber) {
    columns.forEach((column) => {
      let cards = column.getElementsByClassName('product-card')
      cards = Array.from(cards)
      let neighbor = cards[rowNumber]
      if (neighbor) {
        let neighborTitleHeight =
          neighbor.querySelector('.varied-height').clientHeight
        let difference = rowMaxHeight - neighborTitleHeight
        let productPush = neighbor.querySelector('.product-details-push')
        productPush.style.height = `${Math.max(0, difference)}px`
      }
    })
  }

  renderLayoutGrid() {
    if (!this.props.isInitialLoad) {
      if (this.props.products && this.props.products.length === 0) {
        return (
          <div className='no-results empty-state'>
            <AloIcon />
            <div>
              <h3 className='empty-header'>
                We looked but this search has zero matches
              </h3>
              <a className='see-more' href='#'>
                Try using different filter options
              </a>
            </div>
          </div>
        )
      } else if (this.props.products) {
        let productTiles = this.props.products.map((product, idx) => {
          return (
            <ThemeProvider theme={LightTheme}>
              <BoxComponent idx={idx} product={product} />
            </ThemeProvider>
          )
        })
        return (
          <InfiniteScroll
            hasMore={this.props.hasMore()}
            loadMore={() => this.props.onPaginate()}
          >
            {this.renderLayout(productTiles)}
          </InfiniteScroll>
        )
      }
    }
  }

  renderLoadingCards() {
    if (this.props.loading || this.props.isInitialLoad) {
      let loadingCards = new Array(12).fill(null).map((card, idx) => (
        <div key={idx} className='product'>
          <div className='product-card-loading-container' />
        </div>
      ))

      let loadingCardsClassName = classNames(
        'product-cards',
        'products-grid',
        'product-cards-loading',
        {
          list: this.props.layout === 'list'
        }
      )
      return <div className={loadingCardsClassName}>{loadingCards}</div>
    }
  }

  render() {
    return (
      <MainProductMasory
        className='product-masonry'
        ref={(node) => {
          this.productMasonry = node
        }}
      >
        {this.renderLayoutGrid()}
        {this.renderLoadingCards()}
      </MainProductMasory>
    )
  }
}

ProductMasonry.propTypes = {
  hasMore: PropTypes.func,
  layout: PropTypes.string,
  loading: PropTypes.bool,
  isInitialLoad: PropTypes.bool,
  products: PropTypes.array,
  onPaginate: PropTypes.func
}

export default ProductMasonry
 